var React                     = require('react');
var IconValueRight            = require('fdna-common-components/dist/components/Icon/IconValue/IconValueRight')
var RegisterNewAccount        = require('../RegisterNewAccount/RegisterNewAccount');
var RegisterCompleteAccount   = require('../RegisterCompleteAccount/RegisterCompleteAccount');
var SignupValidation          = require('../../classes/signUpFormValidations');
var HipaaCompliant 			  = require('../../../common/components/HipaaCompliant/HipaaCompliant');
var SectionTitle              = require('fdna-common-components/dist/components/Title/SectionTitle');
var md5                       = require('md5');
var _                         = require('lodash');

import {trackEvent}	from 'fdna-common-components/dist/libs/utils';
import { AUTH_LIBRARY_APP } from '../../../config/auth';
import LibraryDescription from '../Description/Library';
import { emailWithMessage } from '../../../common/staticMail';

var Network                   = require("common/network/Network");

Network.registerModule(require('../../network/networkRegister'));

var RegisterContainer = React.createClass({

    componentDidMount: function() {
        if(window.location.hash == '#complete_account') {
            this.checkForUserDetails();
        }
        window.addEventListener("hashchange", this.handleHashChange);

        trackEvent({category: "Register", action: "Registration Form Page 1 Loaded"});

        this.getAllCountries();
    },

    checkForUserDetails: function() {
        let state = this.state.new_account; 
        if (state.first_name == '' &&
            state.last_name == '' &&
            state.email == '') {
                window.location.hash = "new_account";
         }
    },

    getAllCountries: function() {
        var state = this.state;
        Network.register.getAllCountries().$promise.then(function(result) {
            if(result) {
                state.country_list = result
            }
            window.location.hash = "new_account";
        }).catch(function () {
            window.location.hash = "new_account";
        });
    },

    handleHashChange: function(info) {
        var state = this.state;
        if(window.location.hash == '#new_account' || window.location.hash == '#complete_account') {
            state.step = window.location.hash;
            this.setState(state);
        } else {
            window.location.href = window.location.origin
        }
        if(window.location.hash == '#complete_account') {
            this.checkForUserDetails();
        }
        // console.log(state, window.location.hash)
        // state.step = window.location.hash;
        // this.setState(state);
    },

    getInitialState: function() {
        return {
            step: "#new_account",

            new_account: {
                first_name: this.props.first_name,
                first_name_valid: true,
                last_name: this.props.last_name,
                last_name_valid: true,
                email: this.props.email,
                email_valid: true
            },


            complete_account: {
                password: "",
                password_valid: true,
                confirm_password: "",
                confirm_password_valid: true,
                title: "",
                title_valid: true,
                professions: [],
                professions_valid: true,
                institute: "",
                institute_valid: true,
                country: "",
                country_id: "",
                country_valid: true,
                specialities: [],
                specialities_valid: true,
            },

            new_account_has_error: false,
            new_account_error_msg: this.props.domain_redirected == 'true' ? "You have been redirected. Please use the current domain to access Face2Gene with your email." : "",

            complete_account_has_error: false,
            complete_account_error_msg: "",

            country_list: []
        }
    },

    getDefaultProps: function() {
        return {
            first_name: '',
            last_name: '',
            email: '',
            domain_redirected: '',
        };
    },

    onNewAccoundFieldsChange: function(fields) {
        var state = this.state;
        state.new_account.first_name = fields.first_name;
        state.new_account.last_name  = fields.last_name;
        state.new_account.email      = fields.email;
        state.new_account.accept_tos = fields.accept_tos;

        state.new_account_error_msg = "";
        this.setState(state);
    },

    onNewAccountContinue: function(purposeSelection) {
        var state = this.state;

        var lastNameValid = state.new_account.last_name.trim().length > 1;
        state.new_account.last_name_valid = lastNameValid;

        var emailValid = SignupValidation.checkEmail(this.state.new_account.email);
        state.new_account.email_valid = emailValid;

        if(!lastNameValid) {
            state.new_account_error_msg = "Please enter your full first name / last name";
            state.new_account_has_error = true;
            state.new_account.last_name_valid = false;

            this.refs["register-comp"].focusByName("last_name");
        } else if (!emailValid) {
            state.new_account_error_msg = "Please check your email address";
            state.new_account_has_error = true;
            state.new_account.email_valid = false;

            this.refs["register-comp"].focusByName("email");
        } else {
            state.new_account_error_msg = "";
            state.new_account_has_error = false;


            var self = this;
            Network.register.checkEmailAvilable(this.state.new_account.email).$promise.then(function(result) {
                if(result.found) {
                    state.new_account_error_msg = (<span>Email address already exists. <a href={ "/auth/sign-in?app=" + this.props.app }>Click here</a> to Sign In</span>);
                    state.new_account_has_error = true;
                    state.new_account.email_valid = false;
                } else {

                    var newAccount = _.assign({}, _.pick(state.new_account, ['first_name', 'last_name', 'email']), {health_care : purposeSelection.healthCare, who_am_i :purposeSelection.label});

                    var leadCreateAjax = Network.register.createLead(newAccount);
                    if(!purposeSelection.healthCare) {
                        Network.register.addNonHeathProfessional(newAccount);
                    }
                    if (!purposeSelection.healthCare)
                    {
                        leadCreateAjax.$promise.then(function() {
                            window.location.href = purposeSelection.url;
                        }, function() {
                            window.location.href = purposeSelection.url;
                        });
                    }
                    else
                    {
                        trackEvent({category:"Register",action:"Registration Form Page 2 Loaded", label: ""});
                        window.location.hash = "complete_account";
                        state.step = "complete_account";
                    }

                }
                this.setState(state);
            }.bind(this),
            function (result) {
                var result = JSON.parse(result.response);
                if (typeof result.server_url == 'string') {
                    var params = '';
                    params += '?domain_redirected=true' +
                        '&first_name=' + state.new_account.first_name +
                        '&last_name=' + state.new_account.last_name +
                        '&email=' + state.new_account.email;
                    window.location.href = result.server_url + 'auth/sign-up' + params;
                } else if (result.server_url == false) {
                    self.setState({new_account_error_msg: "Your email address is unauthorized."});
                }
            });

        }
        this.setState(state);
    },


    onCompleteAccountChange: function(fields, changedField) {
        var state = this.state;
        state.complete_account.password         = fields.password;
        state.complete_account.confirm_password = fields.confirm_password;
        state.complete_account.title            = fields.title;
        state.complete_account.professions      = fields.professions;
        state.complete_account.institute        = fields.institute;
        state.complete_account.country          = fields.country;
        state.complete_account.country_id          = fields.country_id;
        state.complete_account.specialities     = fields.specialities;
		state.complete_account.promo            = fields.promo;
        state.complete_account_error_msg        = "";


        if(changedField && changedField.indexOf("password") > -1) {
            state.complete_account.password_valid         = true;
            state.complete_account.confirm_password_valid = true;
        }

        this.setState(state);
    },

    onCompleteAccountContinue: function() {
        var state = this.state;
        var passwordResult = SignupValidation.checkPassword(state.complete_account.password, state.complete_account.confirm_password);

        var passwordValid = passwordResult.valid;
        state.complete_account.password_valid         = passwordValid;
        state.complete_account.confirm_password_valid = passwordValid;

        var institute_valid = state.complete_account.institute.length > 1;

        state.complete_account.institute_valid = institute_valid;

        if(!passwordValid) {
            state.complete_account_error_msg = passwordResult.error;

            this.setState(state);

            this.refs["register-comp"].focusByName("password");

        } else if(!institute_valid) {
            state.complete_account_error_msg = "Please enter your institution's name";

            this.setState(state);

        } else {
            var form = {
                email       : this.state.new_account.email,
                password    : md5(this.state.complete_account.password),
                title       : this.state.complete_account.title,
                first_name  : this.state.new_account.first_name,
                last_name   : this.state.new_account.last_name,
                professions : _.map(this.state.complete_account.professions, 'profession_id'),
                specialities: _.map(this.state.complete_account.specialities, 'speciality_id'),
                institution : this.state.complete_account.institute,
                country     : this.state.complete_account.country,
                country_id     : this.state.complete_account.country_id,
				promo		: this.state.complete_account.promo,
                accepted_tos: this.state.new_account.accept_tos ? 1 : 0,
                userAgent   : navigator.userAgent,
                default_case_type : ""
            };

            Network.register.register(form).$promise.then(function() {
				let base = document.getElementsByTagName('base')[0].href,
					url = base;

				switch (this.props.app) {
					case AUTH_LIBRARY_APP:
						url = base + '/library';
						break;
				}
                trackEvent({category:"Register",action:"Register Successfully", label: ""}, () => {
                    window.location.href = url;
                });
            }.bind(this)).catch(function() {

                var state = this.state;
                state.complete_account_error_msg = (<span>A general error has occurred. Please contact <a href={emailWithMessage.errorSigningUp} target="_top">support@fdna.com</a></span>);
                this.setState(state);

            }.bind(this));
        }


    },

	// Render
	renderHeader() {
		switch(this.props.app) {
			case AUTH_LIBRARY_APP:
				return (
					<SectionTitle title="Library | LMD (London Medical Database) - Trusted Dysmorphology" />
				);
			default:
				return null;
		}
	},

	renderContent() {
		switch(this.props.app) {
			case AUTH_LIBRARY_APP:
				return (
					<div className="s-c-content">
						<LibraryDescription />
					</div>
				);
			default:
				return null;
		}
	},

    render: function() {

        var registerComponent = '';

        if(this.state.step == "#new_account") {
            registerComponent = (
                <RegisterNewAccount
                    ref="register-comp"
                    {...this.state.new_account}
                    onFieldsChange={this.onNewAccoundFieldsChange}
                    onContinue={this.onNewAccountContinue}
					error_message={this.state.new_account_error_msg}
					app={ this.props.app } />
            );
        } else {
        	registerComponent = (
                <RegisterCompleteAccount
                    ref="register-comp"
                    {...this.state.complete_account}
                    country_list={this.state.country_list}
                    onFieldsChange={this.onCompleteAccountChange}
                    onContinue={this.onCompleteAccountContinue}
					error_message={this.state.complete_account_error_msg} />
            );
        }

		var mainClasses = ["register-login-container"];
		if (this.props.app) {
			mainClasses.push("app-" + this.props.app);
		}

        return (
            <div className={mainClasses.join(" ")}>
                {this.state.step == "#new_account" ?  
                    <div className="welcome-banner-register">
                        <div className="container">
                            <div className="top-hippa fields-tbl">
                                <div>
                                </div>
                                <div className="f-d-align-right c-h-hipaa">
                                    <HipaaCompliant />
                                </div>
                            </div>
                            <div className="welcome-text">Welcome!</div>
                        </div>
                    </div>
                    :   <div className="top-hippa fields-tbl">
                            <div>
                            </div>
                            <div className="f-d-align-right c-h-hipaa">
                                <HipaaCompliant />
                            </div>
                        </div>
                }

                <div className="register-container">
					{ this.renderHeader() }
					<div className="s-c-form">
						{ registerComponent }
					</div>
					{ this.renderContent() }
                </div>
            </div>
        )
    }
});


module.exports = RegisterContainer;



// WEBPACK FOOTER //
// ./auth/components/RegisterContainer/RegisterContainer.jsx